














































import {Component, Vue} from "vue-property-decorator";
import {AuthService, IRegisterRequest} from "../services/auth.service";
import {HashMap} from "../services/base.service";

@Component({
    name: "Register"
})
export default class Register extends Vue {

    private initialized = false;
    private auth!: AuthService;
    private request!: IRegisterRequest;
    private errors: HashMap<string> = {};
    private registered = false;

    private clear() {
        this.request = {
            firstName: "",
            lastName: "",
            email: "",
            password: "",
        }
    }

    private mounted() {
        this.clear();
        this.auth = new AuthService();
        this.initialized = true;
    }

    private async submit() {
        const response = await this.auth.register(this.request);
        if (response.success) this.registered = true;
        else this.errors = response.error;
    }
}
